export default __webpack_public_path__ + "static/media/foto3@3x.55508c61.png";